






import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomErrorTooltip extends ComponentVue {
  @Prop({
    type: String,
    default: ''
  })
  message!: string

  get fails() {
    return this.message !== ''
  }
}
